import React from 'react';
import {
  EnvironmentalControlBoardJudgment as EnvironmentalControlBoardJudgmentModel,
  EnvironmentalControlBoardJudgments as EnvironmentalControlBoardJudgmentsModel,
} from 'pages/Search/models';
import { EnvironmentalControlBoardJudgment, TableHeader } from '../';
import { Empty, Row } from 'antd';
import { BasicTable, AttributeValuePair, tabSelector } from 'common';
import { useSelector } from 'react-redux';
import { ResultTypeName } from 'pages/Search/Search.types';

const EnvironmentalControlBoardJudgments: React.FC<{
  judgments: EnvironmentalControlBoardJudgmentsModel;
  groupName: string;
  resultType: ResultTypeName;
  resultItemIndex: number;
}> = ({
  judgments: { header, items, loadDate },
  groupName,
  resultType,
  resultItemIndex,
}) => {
  const tabName = useSelector(tabSelector);

  return !!items.length ? (
    <>
      <TableHeader
        title={header}
        items={items}
        group={groupName}
        documentType="environmentalControlBoardJudgments"
        tabName={tabName}
        resultType={resultType}
        resultItemIndex={resultItemIndex}
      />
      <BasicTable
        items={items}
        renderRow={(
          text: string,
          record: EnvironmentalControlBoardJudgmentModel,
          index: number,
        ) => {
          return (
            <EnvironmentalControlBoardJudgment
              key={record.guid}
              judgment={record}
              index={index}
              resultType={resultType}
              resultItemIndex={resultItemIndex}
            />
          );
        }}
      />
      <AttributeValuePair
        attribute="Data Loaded"
        value={loadDate}
        valueType="date"
      />
    </>
  ) : (
    <>
      <Row type="flex" justify="center" align="middle">
        <Empty description={`No ECBs Found (${header})`} />
      </Row>
    </>
  );
};

export default EnvironmentalControlBoardJudgments;
